import { render, staticRenderFns } from "./share-order-record.vue?vue&type=template&id=752357d8&scoped=true"
import script from "./share-order-record.vue?vue&type=script&lang=js"
export * from "./share-order-record.vue?vue&type=script&lang=js"
import style0 from "./share-order-record.vue?vue&type=style&index=0&id=752357d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752357d8",
  null
  
)

export default component.exports